import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { navigateWizard } from '../../actions';
import PageLayout from '../../components/PageLayout';

const StudyStartDateSubmittedPage = ({ dispatchWizardNav }) => {
  const { REACT_APP_PLATFORM_DASHBOARD: PLATFORM_DASHBOARD_URL } = process.env;

  const handleApplyDefault = event => {
    event.preventDefault();

    // TODO: See if there is a better way to do this
    dispatchWizardNav({ dir: 'back' });
    dispatchWizardNav({ dir: 'back' });
  };

  return (
    <PageLayout title="Thanks for letting us know!">
      <div className="row-spacer">
        <p>
          In the meantime, you can browse and select another of our hundreds of supported schools if
          you'd like to continue to apply to get a quote.{' '}
        </p>
      </div>
      <div className="row">
        <div className="col col--auto">
          <a href={`${PLATFORM_DASHBOARD_URL}`} className="link-button link-button--inverted">
            Go to dashboard
          </a>
        </div>
        <div className="col col--auto">
          <a href="/" className="link-button" onClick={handleApplyDefault}>
            Find another school
          </a>
        </div>
      </div>
    </PageLayout>
  );
};

StudyStartDateSubmittedPage.propTypes = {
  dispatchWizardNav: PropTypes.func.isRequired,
};

export const mapDispatchToProps = {
  dispatchWizardNav: navigateWizard,
};

export { StudyStartDateSubmittedPage };

export default connect(null, mapDispatchToProps)(StudyStartDateSubmittedPage);
